import { render, staticRenderFns } from "./PopUpSearch.vue?vue&type=template&id=2922455c&scoped=true"
import script from "./PopUpSearch.vue?vue&type=script&lang=js"
export * from "./PopUpSearch.vue?vue&type=script&lang=js"
import style0 from "./PopUpSearch.vue?vue&type=style&index=0&id=2922455c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922455c",
  null
  
)

export default component.exports